import { useGetPlatformInfosecSettings } from "~/api/useInfosecLevels";
import { useAllowedInfosecLevels, useInfosecFeatureEnabled } from "~/hooks";

// Resolves whether a saved chat must be classified and the levels the user may pick, shared by the save
// dialog and the share modal. `infosecEnabled === undefined` means the platform setting hasn't resolved
// yet — callers keep saving blocked then so an infosec-required deployment can't slip an unclassified save.
export function useChatSaveInfosec() {
  const featureEnabled = useInfosecFeatureEnabled();
  const platformInfosec = useGetPlatformInfosecSettings();
  const infosecLevels = useAllowedInfosecLevels(undefined, { enabled: featureEnabled });

  // Off feature shell ⇒ definitively false (no classification concept); on an infosec deployment, undefined
  // while the setting resolves keeps saving blocked.
  const infosecEnabled = featureEnabled ? platformInfosec.data?.enabled : false;

  return { infosecEnabled, infosecLevels };
}
